import React from 'react';
import { SpeechToTextLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAudioToTextConfig } from '@/data/landingConfig/landingAudioToTextConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AudioToText } from './schemaObject';

interface Props {}
const AudioToText: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AudioToText} />
			<SpeechToTextLandingTemplate
				data={landingAudioToTextConfig}
				funnelLinkService={GenerateLandingLinkService.funnelSpeechToText()}
			/>
		</>
	);
};

export default AudioToText;
